import {createContext} from 'react'

export const CustomerReportContext = createContext({
  customerGroupData: [],
  isCustomerGroupLoading: false,
  customerGroupFilters: {},
  onCustomerGroupSortingChange: (key: string, order: string) => {},
  handleCustomerGroupReportDateChange: (startDate: any, endDate: any) => {},
  onChangeCustomerGroupFilter: (value: any) => {},

  customerTypeData: [],
  isCustomerTypeLoading: false,
  customerTypeFilters: {},
  onCustomerTypeSortingChange: (key: string, order: string) => {},
  handleCustomerTypeReportDateChange: (startDate: any, endDate: any) => {},

  customerGroups: [] as any[],
  isCustomerGroupsLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  customerTypeEntityPerformanceChartData: [] as any,
  isCustomerTypeEntityPerformanceChartDataLoading: false,
  onCustomerTypeEntityPerformanceChartIdChange: (id: string) => {},
  onCustomerTypeEntityPerformanceChartViewChange: (e: any) => {},
  onCustomerTypeEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  customerTypeEntityPerformanceChartFilters: {} as any,

  allEntityPerformanceChartData: [] as any,
  isAllEntityPerformanceChartDataLoading: false,
  onAllEntityPerformanceChartIdChange: (id: string) => {},
  onAllEntityPerformanceChartViewChange: (e: any) => {},
  onAllEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  allEntityPerformanceChartFilters: {} as any,
})

export const SalesRepReportContext = createContext({
  salesRepData: [],
  isSalesRepLoading: false,
  salesRepFilters: {},
  onSalesRepSearch: (value: string) => {},
  onSalesRepSortingChange: (key: string, order: string) => {},
  handleSalesRepReportDateChange: (startDate: any, endDate: any) => {},
  onChangeSalesRepTypeFilter: (value: any) => {},

  salesRepTypes: [] as any[],
  isSalesRepDropdownLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,
})

export const SalesRepTypeReportContext = createContext({
  salesRepTypeData: [],
  isSalesRepTypeLoading: false,
  salesRepTypeFilters: {},
  onSalesRepTypeSortingChange: (key: string, order: string) => {},
  handleSalesRepTypeReportDateChange: (startDate: any, endDate: any) => {},
  onChangeSalesRepTypeFilter: (value: any) => {},

  salesRepTypes: [] as any[],
  isSalesRepDropdownLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,
})
